import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { ByHomeownerContainer, PrepayContainer, WithDepositContainer } from './containers';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useSelector } from 'react-redux';
import { selectRentTermsFilter } from 'shared/selectors/advancedFilters';

export const RentTermsContainer: FC = () => {
  const { label } = useSelector(selectRentTermsFilter);

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        <ByHomeownerContainer />
        <WithDepositContainer />
        <PrepayContainer />
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
